import { AllKycScreenRouteNames } from './config'
import { INVALID_NAVLINK } from './errors'

export default function getRouteFromNavLink(navlink: string) {
  const routeName = navlink.split('kyc/')[1]

  /**
   * TechTODO: use react-error-boundary component to handle this error and show appropriate UI
   */
  if (!routeName) {
    throw new Error(INVALID_NAVLINK)
  }

  // TechTODO: figure out a type guard for this if that makes sense
  return routeName as AllKycScreenRouteNames
}
